export const GRID_COLUMNS = 12;
export const MOBILE_GRID_COLUMNS = 12;
export const STUDIO_DESKTOP_CANVAS_WIDTH = 1200;
export const STUDIO_MOBILE_CANVAS_WIDTH = 375;

export const MIN_ZOOM = 0.5;
export const MAX_ZOOM = 2.0;
export const ZOOM_STEP = 0.1;
export const PRESET_ZOOMS = [10, 25, 50, 75, 100, 200];

export const FONT_WEIGHT = {
    THIN: 100,
    EXTRA_LIGHT: 200,
    LIGHT: 300,
    REGULAR: 400,
    MEDIUM: 500,
    SEMI_BOLD: 600,
    BOLD: 700,
    EXTRA_BOLD: 800,
    BLACK: 900,
} as const;
